<ly-auth>
  <form [formGroup]="forgotPasswordForm" (submit)="submit()">
    <div class="header">
      <div class="header-logo">
        <a href="https://dodd.ly" target="_blank"><ly-logo></ly-logo></a>
      </div>
    </div>
    <div class="mb-2">
      <div class="form-control w-full mt-4">
        <label class="label">Email address</label>
        <input
          type="email"
          class="input input-bordered w-full"
          formControlName="email"
          pInputText
          placeholder="Email address"
        />
      </div>

      <ly-callout *ngIf="invalidEmail" class="mt-3" icon="error" type="negative"
        >Invalid email</ly-callout
      >
      <ly-callout
        *ngIf="successMessage"
        class="mt-3"
        icon="check"
        type="positive"
        >Reset link sent successfully. Please check your inbox.</ly-callout
      >
    </div>
    <button type="submit" class="button mt-2 fluid indigo">
      Send Reset Link
    </button>
    <div class="text-center mt-4 account-not-exists">
      Don't have an account yet?
      <a
        routerLink="/sign-up"
        class="inline-block hover:text-primary hover:underline hover:cursor-pointer transition duration-200"
      >
        Create an account
      </a>
    </div>
  </form>
</ly-auth>
